import React from 'react';

interface PlayPauseButtonProps {
    isPlaying: boolean;
    onToggle: () => void;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({ isPlaying, onToggle }) => {
    return (
        <button
            onClick={onToggle}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 15px',
                borderRadius: '3px',
                backgroundColor: isPlaying ? '#dc3545' : '#28a745',
                color: 'white',
                border: 'none',
                //borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                minWidth: '120px',
                justifyContent: 'center'
            }}
            // onMouseEnter={(e) => {
            //     e.currentTarget.style.transform = 'translateY(-1px)';
            //     e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
            // }}
            // onMouseLeave={(e) => {
            //     e.currentTarget.style.transform = 'translateY(0)';
            //     e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            // }}
        >
            {isPlaying ? '⏸️ Pause' : '▶️ Play'}
        </button>
    );
};

export default PlayPauseButton;